import React, { useCallback, useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { GET_DASHBOARD_TOP_PORT } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Card, CardHeader } from "@mui/material";
import { genericPost } from "../../services/authServices";
import { t } from "../../constants/translationHelper";



const ChartTemplate = ({ labels, series }) => {

    const colors = [
        '#261CC1',
        '#185DA7',
        '#3A9AFF',
        '#1C0770',
        '#0671FF',
        '#8900CD',
        '#003B88',
        '#003399',
        '#FF7145',
        '#265060'
    ];

    const options = {
        chart: {
            type: "donut",
            height: 300
        },

        labels: labels,
        colors: colors,

        legend: {
            show: true,
            position: "bottom",
            fontSize: "12px"
        },

        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(1) + "%";
            },
            style: {
                fontSize: "12px",
                fontWeight: 300,     // light font
                colors: ["#ffffff"]  // white text
            },
            dropShadow: {
                enabled: false
            }

        },

        plotOptions: {
            pie: {
                donut: {
                    size: "65%",   // donut thickness
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Total",
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                            }
                        }
                    }
                }
            }
        },

        tooltip: {
            y: {
                formatter: function (val) {
                    return val.toLocaleString() + " Containers";
                }
            }
        },

        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 220
                    },
                    legend: {
                        position: "bottom"
                    }
                }
            }
        ]
    };

    return (
        <div id="chart">
            {series.length === 0 ? (
                <p>Loading...</p>
            ) : (
                <ReactApexChart
                    options={options}
                    series={series}
                    type="donut"
                    height={300}
                />
            )}
        </div>
    );
};

const TopPortOfLoading = () => {
    const [topPorts, setTopPorts] = useState([]);
    const [labels, setLabels] = useState([]);
    const [series, setSeries] = useState([]);
    const { token } = useContext(AuthContext);

    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 1 };
            const response = await genericPost(GET_DASHBOARD_TOP_PORT, payload);

            if (response.data.success && response.data.data?.portOfLoading) {
                const ports = response.data.data.portOfLoading;
                const labelsData = ports.map((item) => item.loading?.portName || "-");
                const seriesData = ports.map((item) => Number(item.totalContainers || 0));
                setTopPorts(ports);
                setLabels(labelsData);
                setSeries(seriesData);
            }
        } catch (error) {
            console.error("Error fetching Top Port Of Loading data", error);
        }
    }, [token]);

    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    const headerStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontSize: "12px",
        fontWeight: "400",
        color: "#666",
    };

    return (
        <>
            <Card
                variant="outlined"

                style={{ display: "flex", gap: "10px" }}>
                <div
                    style={{ flex: 1, padding: "0px", width: "50%" }}
                >
                    <CardHeader title={t("Top Port Of Loading")} titleTypographyProps={{
                        fontWeight: 700,
                        fontSize: "16px"
                    }} />

                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "left",
                        }}
                    >

                        <tbody>
                            {topPorts.length > 0 ? (
                                topPorts.map((row, index) => {
                                    const color = rowColors[index % rowColors.length];

                                    return (
                                        <React.Fragment key={index}>
                                            <tr
                                                style={{
                                                    borderBottom: "1px solid #eee",
                                                    backgroundColor: color,
                                                    color: "#fff",
                                                    height: "30px",


                                                }}
                                            >
                                                <td style={{ padding: "5px", fontSize: "12px", paddingLeft: "18px", }}>
                                                    {row.loading?.portName || ""},{" "}
                                                    {row.loading?.country?.name || ""}
                                                </td>

                                                <td style={{ padding: "5px", fontSize: "12px" }}>
                                                    {row.totalContainers} - Containers
                                                </td>
                                            </tr>

                                            <tr style={{ height: "30px" }}></tr>
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                        {t("No data available")}
                                    </td>
                                </tr>
                            )}
                        </tbody>


                    </table>
                </div>

                <div
                    style={{
                        flex: 1,
                        padding: "0px",
                        width: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <ChartTemplate
                        title={t("Top Supplier")}
                        labels={labels}
                        series={series}
                    />
                </div>
            </Card>


        </>

    );
};

export default TopPortOfLoading;


const rowColors = [
    '#1E3A8A', '#6D28D9', '#BE123C', '#065F46', '#B45309', '#0F766E', '#7C2D12', '#4C1D95', '#374151', '#14532D'
];